module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/iniciar-reclamacion.component.css
// module id = ./src/app/iniciar-reclamacion.component.css
// module chunks = main